/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderDailyPointDTOFromJSON, OrderDailyPointDTOToJSON, } from './OrderDailyPointDTO';
import { MarketplaceOrderBreakdownDTOFromJSON, MarketplaceOrderBreakdownDTOToJSON, } from './MarketplaceOrderBreakdownDTO';
/**
 * Check if a given object implements the OrderDashboardDTO interface.
 */
export function instanceOfOrderDashboardDTO(value) {
    return true;
}
export function OrderDashboardDTOFromJSON(json) {
    return OrderDashboardDTOFromJSONTyped(json, false);
}
export function OrderDashboardDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'from': json['from'] == null ? undefined : (new Date(json['from'])),
        'to': json['to'] == null ? undefined : (new Date(json['to'])),
        'ordersCount': json['ordersCount'] == null ? undefined : json['ordersCount'],
        'unitsCount': json['unitsCount'] == null ? undefined : json['unitsCount'],
        'revenueUsd': json['revenueUsd'] == null ? undefined : json['revenueUsd'],
        'netProfitUsd': json['netProfitUsd'] == null ? undefined : json['netProfitUsd'],
        'profitPercent': json['profitPercent'] == null ? undefined : json['profitPercent'],
        'productCostUsd': json['productCostUsd'] == null ? undefined : json['productCostUsd'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'salesTaxUsd': json['salesTaxUsd'] == null ? undefined : json['salesTaxUsd'],
        'cancelledCount': json['cancelledCount'] == null ? undefined : json['cancelledCount'],
        'returnedCount': json['returnedCount'] == null ? undefined : json['returnedCount'],
        'refundLossUsd': json['refundLossUsd'] == null ? undefined : json['refundLossUsd'],
        'unknownProfitCount': json['unknownProfitCount'] == null ? undefined : json['unknownProfitCount'],
        'marketplaces': json['marketplaces'] == null ? undefined : (json['marketplaces'].map(MarketplaceOrderBreakdownDTOFromJSON)),
        'daily': json['daily'] == null ? undefined : (json['daily'].map(OrderDailyPointDTOFromJSON)),
    };
}
export function OrderDashboardDTOToJSON(json) {
    return OrderDashboardDTOToJSONTyped(json, false);
}
export function OrderDashboardDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'from': value['from'] == null ? undefined : ((value['from']).toISOString().substring(0, 10)),
        'to': value['to'] == null ? undefined : ((value['to']).toISOString().substring(0, 10)),
        'ordersCount': value['ordersCount'],
        'unitsCount': value['unitsCount'],
        'revenueUsd': value['revenueUsd'],
        'netProfitUsd': value['netProfitUsd'],
        'profitPercent': value['profitPercent'],
        'productCostUsd': value['productCostUsd'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'referralFeeUsd': value['referralFeeUsd'],
        'salesTaxUsd': value['salesTaxUsd'],
        'cancelledCount': value['cancelledCount'],
        'returnedCount': value['returnedCount'],
        'refundLossUsd': value['refundLossUsd'],
        'unknownProfitCount': value['unknownProfitCount'],
        'marketplaces': value['marketplaces'] == null ? undefined : (value['marketplaces'].map(MarketplaceOrderBreakdownDTOToJSON)),
        'daily': value['daily'] == null ? undefined : (value['daily'].map(OrderDailyPointDTOToJSON)),
    };
}
